<template>
    <template-layout>
        <template slot="drawers"></template>

        <template slot="menu">
            <reports-menu />
        </template>

        <template slot="content">
            <v-container>
                <v-toolbar flat dense color="transparent" height="60" class="mb-2">
                    <v-toolbar-title>
                        <span class="headline">Reporte OIA</span>
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-toolbar-title></v-toolbar-title>
                </v-toolbar>

                <v-row>
                    <v-col cols="12" sm="6">
                        <v-card>
                            <v-card-text>
                                <v-menu
                                    v-model="dateMenu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            label="Fecha"
                                            color="accent"
                                            v-model="dateRangeText"
                                            prepend-inner-icon="mdi-calendar"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>

                                    <v-date-picker
                                        v-model="dateRange"
                                        no-title
                                        :first-day-of-week="1"
                                        locale="es-AR"
                                        range
                                        event-color="green lighten-1"
                                    ></v-date-picker>
                                </v-menu>

                                <v-btn
                                    dark
                                    color="green darken-1"
                                    @click="downloadReport"
                                >Generar CSV</v-btn>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </template-layout>
</template>

<script>
import TemplateLayout from '@/layout/TemplateLayoutWithMenu';
import ReportsMenu from './ReportsMenu.vue';

export default {
    components: {
        TemplateLayout,
        ReportsMenu
    },

    data() {
        return {
            isLoading: false,

            dateMenu: false,
            dateRange: [
            ],

            filters: {
                state: 'state.closed'
            }
        };
    },

    computed: {
        dateRangeText() {
            let dates = [...this.dateRange];
            dates.sort();

            if (dates.length > 1) {
                return dates.map(d => this.$moment(d).format('DD/MM/YYYY')).join(' al ');
            }
            else if (dates.length > 0) {
                return this.$moment(this.dateRange[0]).format('DD/MM/YYYY');
            }
            else {
                return '';
            }
        }
    },

    watch: {
        dateRange(val) {
            let dates = [...val];
            dates.sort();

            if (dates.length === 2) {
                this.filters.date = {
                    gte: dates[0],
                    lte: dates[1]
                };
            }
            else {
                this.filters.date = dates[0];
            }
        }
    },

    mounted() {
    },

    methods: {
        async downloadReport() {
            this.isLoading = true;

            let filters = {};
            filters = { ...this.filters };
            filters.offset = 0;
            filters.limit = -1;
            filters.sortBy = 'id';

            let result = await this.$api.get('/api/orders', filters);

            let csv = 'Pedido,Fecha,Monto,Nombre,Factura\n';
            result.records.forEach((row) => {
                csv += [row.id, this.$moment(row.date).format('DD/MM/YYYY'), row.total, row.customer.fullName, row.invoice ? row.invoice.invoiceFormattedNumber : 'N/D'].join(',');
                csv += '\n';
            });

            const anchor = document.createElement('a');
            anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
            anchor.target = '_blank';
            anchor.download = 'reporte-oia.csv';
            anchor.click();
        }
    }
};
</script>

<style lang="scss" scoped>
</style>
